export default {
	setShow: ({commit}, bool) => {
		commit('setShow', bool)
	},
	setCurindex: ({ commit }, index) => {
		commit('setCurindex', index)
	},
	showNav: ({ commit }) => {
		commit('showNav')
	},
	hideNav: ({ commit }) => {
		commit('hideNav')
	},
	hasLogin: ({ commit }) => {
		if(window.localStorage.getItem('token') != null) {
			commit('hasLogin')
		}else {
			console.log('没有登录')
		}
	},
	noLogin: ({ commit }) => {
			commit('noLogin')
	},
	setUsername: ({ commit }, username) => {
		commit('setUsername', username)
	},
	setStarnum: ({ commit }) => {
		commit('setStarnum')
	},
	setFocusnum: ({ commit }) => {
		commit('setFocusnum')
	},
	setFannum: ({ commit }) => {
		commit('setFannum')
	},
	setFabunum: ({ commit }) => {
		commit('setFabunum')
	},
	setSellnum: ({ commit }) => {
		commit('setSellnum')
	},
	setBuynum: ({ commit }) => {
		commit('setBuynum')
	},
	setLikenum: ({ commit }) => {
		commit('setLikenum')
	},
	cutLikenum: ({ commit }) => {
		commit('cutLikenum')
	},
	cutStarnum: ({ commit }) => {
		commit('cutStarnum')
	},
	cutFocusnum: ({ commit }) => {
		commit('cutFocusnum')
	},
	cutFannum: ({ commit }) => {
		commit('cutFannum')
	},
	cutFabunum: ({ commit }) => {
		commit('cutFabunum')
	},
	cutSellnum: ({ commit }) => {
		commit('cutSellnum')
	},
	cutBuynum: ({ commit }) => {
		commit('cutBuynum')
	},
	setPrice: ({ commit}, price) => {
		commit('setPrice', price)
	},
	setImgurl: ({commit}, imgurl) => {
		commit('setImgurl', imgurl)
	},
	setGoodstitle: ({ commit }, goodstitle) => {
		commit('setGoodstitle', goodstitle)
	},
	setGoodsinfo: ({ commit }, goodsinfo) => {
		commit('setGoodsinfo', goodsinfo)
	},
	setKind: ({ commit }, kind) => {
		commit('setKind', kind)
	},
	setPrimecost: ({ commit }, primecost) => {
		commit('setPrimecost', primecost)
	},
	setFreight: ({ commit}, freight) => {
		commit('setFreight', freight)
	},
	setNews: ({ commit }, news) => {
		commit('setNews', news)
	},
	setAddr: ( { commit }, addr) => {
		commit('setAddr', addr)
	},
	setBuyinfo: ({commit}, info) => {
		commit('setBuyinfo', info)
	},
	cutBuyinfo: ({commit}, index) => {
		commit('cutBuyinfo', index)
	},
	setFabuinfo: ({commit}, info) => {
		commit('setFabuinfo', info)
	},
	cutFabuinfo: ({commit}, index) => {
		commit('cutFabuinfo', index)
	},
	setReceive: ({commit}, obj ) => {
		commit('setReceive', obj)
	},
	setDel: ({commit}, obj) => {
		commit('setDel', obj)
	},
	setUserinfo: ({commit}, userinfo) =>{
		commit('setUserinfo', userinfo)
	},
  setDb:({commit},db) =>{
    commit('setDb', db)
  },
  setWebsocket:({commit},websocket) =>{
    commit('setWebsocket',websocket)
  },
  setToken:({commit},token)=>{
	  commit('setToken',token)
  },
  addPages:({commit})=>{
	  commit('addPages')
  },
  setPages:({commit})=>{
    commit('setPages')
  },
  setIsAddPage:({commit})=>{
	  commit('setIsAddPage')
  },
  reSetIsAddPage:({commit})=>{
    commit('reSetIsAddPage')
  },
  setBrand:({commit},brand)=>{
    commit('setBrand',brand)
  },
  setCarForme:({commit},carForme)=>{
	  commit('setCarForme',carForme)
  },
  setBorneMill:({commit},borneMill)=>{
	  commit('setBorneMill',borneMill)
  },
  setCarAge:({commit},carAge)=>{
	  commit('setCarAge',carAge)
  },
  setDisplacement:({commit},displacement)=>{
	  commit('setDisplacement',displacement)
  },
  setFuelType:({commit},fuelType)=>{
	  commit('setFuelType',fuelType)
  },
  setSeatNum:({commit},seatNum)=>{
	  commit('setSeatNum',seatNum)
  },
  setChatMsg:({commit},chatMsg)=>{
    commit('setChatMsg',chatMsg)
  },setWChatUserId:({commit},wChatUserId)=>{
  commit('setWChatUserId',wChatUserId)
},setSendSingleMsgUnsucce:({commit},sendSingleMsgUnsucce) =>{
    commit('setSendSingleMsgUnsucce',sendSingleMsgUnsucce)
  },setSendSingleMsgUnerror:({commit},sendSingleMsgUnerror)=>{
	  commit('setSendSingleMsgUnerror',sendSingleMsgUnerror)
  },setAudio:({commit},audio)=>{
	  commit('setAudio',audio)
  },setChatMsgs:({commit},chatMsgs)=>{
	  commit('setChatMsgs',chatMsgs)
  },setDtask:({commit},dtask)=>{
    commit('setDtask',dtask)
  },setDownTotal:({commit},downTotal)=>{
    commit('setDownTotal',downTotal)
  },setCarUserId:({commit},carUserId)=>{
	  commit('setCarUserId',carUserId)
  },setZhouseTypeIndex:({commit},zhouseTypeIndex)=>{
    commit('setZhouseTypeIndex',zhouseTypeIndex)
  },setZhouseId:({commit},zhouseId)=>{
    commit('setZhouseId',zhouseId)
  },setOldCurrAddr:({commit},oldCurrAddr)=>{
    commit('setOldCurrAddr',oldCurrAddr)
  },setCurrAddr:({commit},currAddr)=>{
    commit('setCurrAddr',currAddr)
  },setPageTag:({commit},pageTag)=>{
    commit('setPageTag',pageTag)
  },setFind:({commit},find)=>{
    commit('setFind',find)
  },setLat:({commit},lat)=>{
    commit('setLat',lat)
  },setLgt:({commit},lgt)=>{
    commit('setLgt',lgt)
  },setWx:({commit},wx)=>{
    commit('setWx',wx)
  },setChatMsgNum:({commit},chatMsgNum)=>{
	  commit('setChatMsgNum',chatMsgNum)
  }
}



// WEBPACK FOOTER //
// ./src/store/action.js